/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AdminSlideListCase = {
    readonly id?: number;
    /**
     * The Accession Number of the Case
     */
    readonly accession?: string | null;
    /**
     * case origin, WPL or PW LIS
     */
    readonly source?: AdminSlideListCase.source;
}

export namespace AdminSlideListCase {

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
        APL = 'apl',
    }


}
